// src/components/vehicles/AssetInformationStep.tsx

import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from '@mui/material';
import { useAddAsset } from '../../../context/AddAssetContext'; // Import the hook
import { ApiSystem } from '../../../state/types';
import { useSession } from '../../../context/SessionContext';

const AssetInformationStep: React.FC = () => {
  // Get everything needed from the context hook
  const { systems, selectedSystem } = useSession()

  const {
    assetId,
    setAssetId,
    assetIdError,
    systemsLoading,
    // setSelectedSystemCode,
    configOptions,
    selectedConfigName,
    setSelectedConfigName,
    noConfigsFound,
  } = useAddAsset();

  return (
    <Box component="form" noValidate autoComplete="off" sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TextField
        label="VIN / Stock #"
        variant="outlined"
        fullWidth
        value={assetId}
        onChange={(e) => setAssetId(e.target.value.toUpperCase())}
        error={!!assetIdError}
        helperText={assetIdError || ''}
      />
      <FormControl fullWidth>
        <InputLabel id="system-select-label">System</InputLabel>
        <Select
          labelId="system-select-label"
          value={selectedSystem?.systemCode}
          disabled={true}
          label="System"
        // onChange={(e) => {
        //   setSelectedSystemCode(e.target.value);
        //   setSelectedConfigName(''); // Reset config on system change
        // }}
        >
          {(systems || []).map((system: ApiSystem) => (
            <MenuItem key={system.systemCode} value={system.systemCode}>
              {system.commonName} ({system.systemCode})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth disabled={!selectedSystem?.systemCode || noConfigsFound}>
        <InputLabel id="config-select-label">Configuration</InputLabel>
        <Select
          labelId="config-select-label"
          value={selectedConfigName}
          label="Configuration"
          onChange={(e) => setSelectedConfigName(e.target.value)}
        >
          {(configOptions || []).map((configName: string) => (
            <MenuItem key={configName} value={configName}>
              {configName}
            </MenuItem>
          ))}
        </Select>
        {noConfigsFound && (
          <FormHelperText error>
            No configurations found for this system.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default AssetInformationStep;